/*
    Generated Enums
*/

export enum AppraisalStatus
{
    All = 1,
    New = 2,
    Completed = 3,
}
export enum EmployeeType
{
    Executive = 1,
    Ceo = 2,
}
export enum RefEntityTypeEnum
{
    Company = 1,
    Department = 2,
    Employee = 3,
    Form = 4,
    FormRating = 5,
    JobLevel = 6,
    Position = 7,
    Rating = 8,
    RefStatusType = 9,
    Section = 10,
}
export enum RefStatusTypeEnum
{
    Active = 1,
    Inactive = 2,
}

/*
    UI Enums
*/

export enum ResponseTypeEnum {
    Result = 1,
    Success = 2,
    Full = 3    
}